import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 16px;

  width: ${(props) => (props.width ? props.width : "100%")};

  max-width: calc(100vw - 367px);
  overflow-x: auto;

  button {
    width: 200px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: calc(100vw - 367px);
  overflow-x: auto;

  /* Fixa a última coluna (ex.: "Ações") à direita, sempre visível, mesmo
     com scroll horizontal. O fundo precisa ser opaco e replicar o listrado/
     hover das linhas, pois a <td> não herda o background do <tr>. */
  ${(props) =>
    props.$sticky &&
    css`
      th:last-child,
      td:last-child {
        position: sticky;
        right: 0;
        box-shadow: -6px 0 8px -6px rgba(0, 0, 0, 0.15);
      }

      th:last-child {
        z-index: 3;
        background-color: #e1e4f0;
      }

      td:last-child {
        z-index: 1;
      }

      tbody tr:nth-child(odd) td:last-child {
        background-color: ${({ theme }) => theme.colors.neutral.white};
      }

      tbody tr:nth-child(even) td:last-child {
        background-color: ${({ theme }) => theme.colors.neutral.gray2};
      }

      tbody tr:hover td:last-child {
        background-color: #d6d6d7;
      }

      tbody tr:nth-child(odd):hover td:last-child {
        background-color: #f1f1f1;
      }
    `}
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 15px;
  width: 100%;
`;

export const TableHeaderCell = styled.th`
  text-align: left;
`;

export const SortIcons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  height: ${(props) => (props.headerHeight ? props.headerHeight : "100%")};
  min-width: 40px;

  span {
    height: 7px;
  }

  svg {
    cursor: pointer;
  }
`;

export const TableCell = styled.td`
  padding: 8px 10px;

  span {
    font-size: 12px;
    justify-self: center;
  }
`;

export const TableRow = styled.tr`
  ${TableCell}, ${TableHeaderCell} {
    padding: 10px;
  }

  transition: 0.2s;
  height: 56px;
  width: 100%;

  cursor: ${(props) => (props.rowClick ? "pointer" : "default")};

  /* Sub-linha da expansão (useExpanded): fundo próprio, sem hover de linha
     clicável — o conteúdo é um painel, não um registro da tabela. */
  ${({ $subRow, theme }) =>
    $subRow &&
    `
    && {
      background: ${theme.colors.neutral.gray2};
      cursor: default;
      height: auto;
    }
  `}

  &:nth-child(even) {
    background: ${({ theme }) => theme.colors.neutral.gray2};
  }

  td:first-child {
    border-radius: 15px 0 0 15px;
  }

  td:last-child {
    border-radius: 0 15px 15px 0;
  }

  th:first-child {
    border-radius: 15px 0 0 15px;
  }

  th:last-child {
    border-radius: 0 15px 15px 0;
  }
`;

export const TableBody = styled.tbody`
  font-size: 12px;
  ${TableRow}:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.neutral.white};

    :hover {
      background-color: #f1f1f1;
      transition: 0.2s;
    }
  }

  ${TableRow}:hover {
    background-color: #d6d6d7;
    transition: 0.2s;
  }
`;

export const TableHead = styled.thead`
  font-size: 12px;
  background-color: #e1e4f0;
  color: ${({ theme }) => theme.colors.neutral.black};

  border-radius: 15px;
`;

export const HeaderItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: ${(props) => (props.align ? props.align : "flex-end")};
  min-height: 80px;

  form {
    width: 100% !important;
    display: block !important;
  }
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 16px;
`;

export const TableFooterRow = styled.div`
  width: fit-content;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 16px;
`;

export const Go = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1px;

  width: 28px !important;
  height: 28px;

  border: 2px solid black;
  border-radius: 9999px;

  cursor: pointer;
`;

export const Bar = styled.div`
  width: 100%;
  height: 64px;
  background: #f5a7cc;
  border-radius: 16px;
`;

export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;

  /* O Wrapper impõe width: 200px a todo button descendente (mesmo precedente
     do botão Go da paginação). */
  width: 28px !important;
  height: 28px;
`;
